export default () => ({
  userPermissions: [],
  lastUpdate: {},
  expectedRecoveryDate: null,
  externalBIMenus: [],
})
